import { HumanMaleBoardPollIcon } from './HumanMaleBoardPollIcon';

/**
 * author: MaksUr
 * id 7016027D-C32A-4462-A9E5-98132FA518B4
 * name human-male-board-poll
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-board-poll.svg
 * tags
 * - People / Family 
 */
export const TeachPollIcon = HumanMaleBoardPollIcon;
export default TeachPollIcon